// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab__title {\n  font-weight: 300;\n  font-size: 32px;\n  color: deepskyblue;\n}\n.tab__body {\n  line-height: 1.2;\n}", ""]);
// Exports
module.exports = exports;
